import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { MB_SALUTATION_NORMALIZER, MbSalutationAdapter } from '../connectors'
import { pluck } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class MbOccSalutationAdapter implements MbSalutationAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load () {
    return this.http.get(this.getEndpoint()).pipe(
      pluck('titles'),
      this.converter.pipeable(MB_SALUTATION_NORMALIZER)
    )
  }

  protected getEndpoint () {
    return this.occEndpoints.buildUrl('titles')
  }
}
